import { motion } from "framer-motion";

const NODES = [
    { x: 80, y: 60 }, { x: 220, y: 120 }, { x: 360, y: 80 },
    { x: 140, y: 240 }, { x: 300, y: 260 }, { x: 460, y: 180 },
    { x: 220, y: 380 }, { x: 400, y: 380 }, { x: 520, y: 320 },
    { x: 60, y: 360 }, { x: 500, y: 60 }, { x: 380, y: 480 },
];

const EDGES = [
    [0, 1], [1, 2], [1, 3], [2, 5], [3, 4], [4, 5], [4, 6],
    [5, 8], [6, 7], [7, 8], [3, 9], [2, 10], [7, 11], [8, 11],
];

export default function NetworkAnimation({ className = "" }) {
    return (
        <div className={`relative w-full h-full ${className}`}>
            <svg
                viewBox="0 0 600 520"
                className="absolute inset-0 w-full h-full"
                preserveAspectRatio="xMidYMid slice"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="edge" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor="#1E90FF" stopOpacity="0" />
                        <stop offset="50%" stopColor="#1E90FF" stopOpacity="0.9" />
                        <stop offset="100%" stopColor="#0A2540" stopOpacity="0" />
                    </linearGradient>
                    <radialGradient id="node-glow">
                        <stop offset="0%" stopColor="#1E90FF" stopOpacity="0.35" />
                        <stop offset="100%" stopColor="#1E90FF" stopOpacity="0" />
                    </radialGradient>
                </defs>

                {EDGES.map(([a, b], i) => {
                    const na = NODES[a]; const nb = NODES[b];
                    return (
                        <motion.line
                            key={i}
                            x1={na.x} y1={na.y} x2={nb.x} y2={nb.y}
                            stroke="#1E90FF"
                            strokeOpacity={0.28}
                            strokeWidth={1.2}
                            initial={{ pathLength: 0, opacity: 0 }}
                            animate={{ pathLength: 1, opacity: 0.4 }}
                            transition={{ duration: 1.2, delay: i * 0.08, ease: "easeOut" }}
                        />
                    );
                })}

                {EDGES.slice(0, 6).map(([a, b], i) => {
                    const na = NODES[a]; const nb = NODES[b];
                    return (
                        <motion.circle
                            key={`p-${i}`}
                            r={3}
                            fill="#1E90FF"
                            cx={na.x}
                            cy={na.y}
                            initial={{ opacity: 0 }}
                            animate={{
                                cx: [na.x, nb.x],
                                cy: [na.y, nb.y],
                                opacity: [0, 1, 0],
                            }}
                            transition={{
                                duration: 3.4,
                                repeat: Infinity,
                                delay: i * 0.6,
                                ease: "easeInOut",
                            }}
                        />
                    );
                })}

                {NODES.map((n, i) => (
                    <g key={i}>
                        <circle cx={n.x} cy={n.y} r={16} fill="url(#node-glow)" />
                        <motion.circle
                            cx={n.x} cy={n.y}
                            r={4}
                            fill="#0A2540"
                            initial={{ scale: 0 }}
                            animate={{ scale: [0.85, 1.15, 0.85] }}
                            transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.15 }}
                        />
                    </g>
                ))}
            </svg>
        </div>
    );
}
